import { Component, EventEmitter, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HomeserveService } from '../../shared/services/homeserve.service';
import { MasterDataService } from '../../shared/services/master-data.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { CONFIG } from '../../../assets/config';
import { environment } from '../../../environments/environment';
import { UrlParamsService } from '../../core/services/url-params.service';
import { ConfirmComponent } from '../../shared/components/confirm/confirm.component';
import * as GetClientRequestMOCK from '../../shared/mocks/get-client-dni-request.mock.json';
import { ClaimStep } from '../../shared/models/claim-step';
import { CodeDescription } from '../../shared/models/code-decription';
import { GetClientRequest } from '../../shared/models/dto/get-client-request';
import { Insured } from '../../shared/models/dto/get-client-response';
import { Relationship } from '../../shared/models/relationship';
import { StorageService } from '../../shared/services/storage.service';
import { ValidationService } from '../../shared/services/validation.service';
import { ClickToCallComponent } from '../click-to-call/click-to-call.component';
import { LlamanosComponent } from '../llamanos/llamanos.component';
import { Language } from '../../shared/models/language';
import { OAuthService } from 'angular-oauth2-oidc';
import { DataLayerService } from '../../core/services/dataLayer.service';
import { StepTrackerService } from '../../core/services/stepTracker.service';
import { MedalliaService } from '../../core/services/medallia.service';

@Component({
  selector: 'datos-contacto',
  templateUrl: './datos-contacto.component.html',
  styleUrls: ['./datos-contacto.component.scss'],
  providers: [DataLayerService]
})
export class DatosContactoComponent {
  @Output() nextStep: EventEmitter<undefined> = new EventEmitter();
  @Output() showC2CButton: EventEmitter<boolean> = new EventEmitter();
  @Output() showStepper: EventEmitter<boolean> = new EventEmitter();
  form: FormGroup = new FormGroup({});
  policies?: Insured[] = [];
  selectedPolicy!: Insured;
  declarantRelationships: Relationship[] = [];
  prefixList: string[];
  typePhoneList: CodeDescription[];
  maxContactsMessage: boolean = false;
  private modalOpen = false;
  typePhoneSelect: string = '';
  typePrimaryPhoneSelect: string = '';
  lang: Language | undefined;
  dni: string;
  urlParams: any = {}
  contactByEmail: boolean = false;
  sessionData: any = {};
  focusAndDeleteAlertEmail: boolean = false;
  correctPhone: boolean = true;
  noDataLoaded: boolean = false;
  homeserveparams: any = [];
  Exito_siniestro = 0;
  get contacts(): FormArray {
    return this.form?.get('contactData')?.get('contacts') as FormArray;
  }

  constructor(
    private formBuilder: FormBuilder,
    private homeserveService: HomeserveService,
    private masterService: MasterDataService,
    private storageService: StorageService,
    private validationService: ValidationService,
    private urlParamsService: UrlParamsService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private oauthService: OAuthService,
    private dataLayerService: DataLayerService,
    private stepTrackerService: StepTrackerService,
    private medalliaService: MedalliaService
  ) {
    this.homeserveService.claimStep = ClaimStep.ContactData;
    this.showC2CButton.emit(true);
    this.prefixList = this.masterService.getPhonePrefixList();
    this.typePhoneList = this.masterService.getTypesPhone();
    this.storageService.clear('terms');
    this.initForm();
    this.homeserveparams = this.urlParamsService.getDecodedParams();
    this.urlParams = this.storageService.get('urlParams');
    this.dni = this.oauthService.getIdentityClaims()['preferred_username'];
    if (!this.homeserveparams.data) {
      this.homeserveparams.data = JSON.parse(JSON.stringify(this.urlParams)).data;
    }
    if (environment.useMock || this.homeserveparams.nif || this.homeserveparams.policy || this.homeserveparams.data) {
      this.getClientData(this.homeserveparams.nif, this.homeserveparams.policy, this.homeserveparams.data);
      if (this.contacts.length === 0) {
        this.newContact(true);
      }
      this.loadMasterData();
      this.translate.onLangChange.subscribe(() => {
        this.loadMasterData();
      });
    } else {
      window.location.href = environment.adeslas;
    }

    //IPD-83
    this.flowUrgencia();

    //IPD-81
    this.medalliaService.initValues();
    
  }

  private flowUrgencia() {
    const modalRef = this.masterService.showPopUpUrgencia();
    modalRef.result.then(
      (result: any) => {
        //IPD-81 
        //(PRIMERA LLAMADA A MEDALLIA) -> SE LLAMA DESDE AQUI PORQUE NO ES POSIBLE METERLA NI EN CONSTRUCTOR NI EN ONINIT, AFTERVIEWINIT ETC...
        // EL CODIGO DE MEDALLIA SE CARGA POR JAVASCRIPT EXTERNO Y EN TIEMPO DE EJECUCION SOLO ESTA DISPONIBLE A PARTIR DE AQUI 
        // SI SE MODIFICA O QUITA EL METODO flowUrgencia() SE DEBE DE MOVER LA LLAMADA HACIA EL PROXIMO EVENTO MAS CERCANO
        this.medalliaService.callMedallia();


        //SI SE SELECCIONAN ESTAS OPCIONES DEBE DERIVAR EN C2C  
        if (result === 'Option1' || result === 'Option2' || result === 'Option3') {
          let motiveC2C : string = "10004_Urgencias";
          let submotiveC2C: string = "";
          this.form.get('isUrgent')?.setValue(true);
          switch(result){
            case 'Option1':
              submotiveC2C = this.translate.instant('urgency.noAccessHome');           
              break;
            case 'Option2':
              submotiveC2C = this.translate.instant('urgency.faucetWater');
              break; 
            case 'Option3':
              submotiveC2C = this.translate.instant('urgency.noLight');
              break; 
          }
          

          this.masterService.createClickToCall(motiveC2C, submotiveC2C);
        }
      },

    );
  }



  ngOnInit(): void {

    this.stepTrackerService.updateStep('0');
    const currentStep = this.stepTrackerService.getCurrentStep();
    this.stepTrackerService.updateNameEvent('modulo_hogar_paso_0');
    const currentNameEvent = this.stepTrackerService.getCurrentEventName();
    this.dataLayerService.addDataToDataLayer({
      'event': currentNameEvent
    });
    this.dataLayerService.addDataToDataLayer({
      'event': 'uaevent',
      'eventCategory': 'Funnel Hogar Siniestros',
      'eventAction': 'modulo_hogar',
      'eventLabel': `Step${currentStep}`
    });

  }

  private initForm() {
    this.form = this.formBuilder.group({
      primaryData: this.formBuilder.group({
        policyId: ['', Validators.required],
        clientName: ['', Validators.required],
        address: ['', Validators.required],
        rightAddress: [null, Validators.required],
        reasonWrongAddress: [null, []],
        housingType: ['', Validators.required],
        policyHolder: [true, Validators.required],
        nif: ['', Validators.required]
      }),
      declarant: this.formBuilder.group({
        name: [''],
        surname: [''],
        secondSurname: [''],
        relationship: ['']
      }),
      contactData: this.formBuilder.group({
        email: ['', [this.validationService.emailValidation]],
        contacts: this.formBuilder.array([]),
        contactByEmail: [true, Validators.required]
      }),
      isUrgent: [false, Validators.required]
    });
    this.storageService.autoSaveForm(this.storageService.contactDataKey, this.form);
    sessionStorage.setItem('step', '1');
  }

  private newContact(firstContact?: boolean) {
    this.contacts.push(
      this.formBuilder.group({
        phone: ['', [Validators.required]],
        typePhone: [this.typePhoneList[0], Validators.required],
        prefixPhone: [this.prefixList[0], Validators.required],
        isInsured: [true, Validators.required],
        isPrimaryContact: firstContact ? [true, Validators.required] : [false, Validators.required]
      })
    );
  }

  private async loadMasterData() {
    this.declarantRelationships = await this.masterService.getRelationships();
  }

  private loadSelectedPolicy() {
    this.homeserveService.setSelectedInsured(this.selectedPolicy);
    this.form.patchValue({
      primaryData: {
        policyId: this.selectedPolicy?.policy,
        clientName: `${this.selectedPolicy?.name} ${this.selectedPolicy?.surname} ${this.selectedPolicy?.secondSurname}`,
        address: this.selectedPolicy?.adressInfo.adress,
        addressCorrect: true,
        housingType: this.form.value.primaryData.housingType ? this.form.value.primaryData.housingType : '',
        policyHolder:
          this.form.value.primaryData.policyHolder !== (undefined || null)
            ? this.form.value.primaryData.policyHolder
            : '',
        nif: this.selectedPolicy?.dni
      }
    });
    this.form.updateValueAndValidity();
  }

  private async getClientData(nif?: string, policy?: string, data?: string) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sessionData: any = this.storageService.get(this.storageService.contactDataKey);
    if (sessionData?.contactData.contacts) {
      const type = sessionData.contactData.contacts.find((contact: any) => contact.isPrimaryContact).typePhone.code;
      this.typePrimaryPhoneSelect = type;
      this.contactByEmail = sessionData.contactData.email ? true : (type === '1' ? true : false);
      this.focusAndDeleteAlertEmail = sessionData.contactData.email ? true : false;
      this.form.get('contactData')?.get('email')?.patchValue(sessionData.contactData.email ? sessionData.contactData.email : '');
    }
    const paramsUrl = this.urlParams;
    this.lang = paramsUrl.lang;
    paramsUrl.lang = this.urlParams.lang.i18nKey;
    paramsUrl.redirectUri = '';
    this.urlParamsService.setUrlParams(paramsUrl);
    if (
      sessionData && ((nif !== '' && nif === sessionData.primaryData?.nif) ||
        (policy !== '' && policy === sessionData.primaryData?.policyId) ||
        (data !== '' && data === sessionData.primaryData?.policyId))
    ) {
      if (sessionData?.contactData?.contacts?.length > 0) {
        for (let index = 0; index < sessionData?.contactData?.contacts?.length; index++) {
          this.newContact();
        }
      }
      this.form.patchValue(sessionData);
    }
    const request: GetClientRequest = environment.useMock
      ? GetClientRequestMOCK
      : {
        dni: this.dni ?? '',
        policy: (data || environment.dataUrl ? data : policy) ?? '',
        auditoryInfo: {
          originCall: CONFIG.originCall,
          transactionId: crypto.randomUUID()
        },
        company: CONFIG.companyId
      };
    try {
      const clientData = await lastValueFrom(this.homeserveService.getClient(request));
      const policiesByDni = clientData.filter(policy => policy.dni ? policy.dni.trim().toUpperCase() === this.dni.trim().toUpperCase() : policy.dni === this.dni);
      if (policiesByDni.length) {
        this.policies = policiesByDni ?? [];
        const selectedPolicyId = this.form?.get('primaryData')?.get('policyId')?.value;
        if (selectedPolicyId) {
          const selected = this.policies.find((policy) => policy.policy === selectedPolicyId);
          if (selected) {
            this.onSelectPolicy(selected);
            this.medalliaService.setValue("NumPoliza_Value", selected?.policy);
            this.medalliaService.setValue("Segmento_1", selected?.segment1? selected?.segment1:"");
            this.medalliaService.setValue("Segmento_2", selected?.segment2? selected?.segment2:"");
            this.medalliaService.setValue("Segmento_3", selected?.segment3? selected?.segment3:"");
          }
          
        }
        if (policiesByDni?.length === 1) {
          this.onSelectPolicy(policiesByDni[0]);
          this.medalliaService.setValue("NumPoliza_Value", policiesByDni[0].policy);
          this.medalliaService.setValue("Segmento_1", policiesByDni[0].segment1? policiesByDni[0]?.segment1:"");
          this.medalliaService.setValue("Segmento_2", policiesByDni[0].segment2? policiesByDni[0]?.segment2:"");
          this.medalliaService.setValue("Segmento_3", policiesByDni[0].segment3? policiesByDni[0]?.segment3:"");
        }
      } else {
        this.noDataLoaded = true;
        this.showStepper.emit(false);
      }
    } catch (error) {
      this.policies = undefined;
      const modalRef = this.modalService.open(LlamanosComponent, {
        centered: true,
        windowClass: 'modal-help',
        backdrop: 'static',
        keyboard: false
      });
      modalRef.componentInstance.motiveLlamanos = '60001';
      modalRef.componentInstance.submotiveLlamanos = 'Fallo en la respuesta de getClient.';
      modalRef.componentInstance.submotiveShown = '';
    }
  }

  onSelectPolicy(policy: Insured) {
    this.lang = this.lang?.i18nKey ? this.lang : (this.masterService.getLanguages().find((lang) => lang.description === policy.language) ?? this.homeserveService.defaultLanguage);
    this.homeserveService.setSelectedLanguage(this.lang);
    this.selectedPolicy = policy;
    this.loadSelectedPolicy();
  }

  onSelectDeclarantRelationship(relationship: Relationship) {
    this.form.get('declarant')?.get('relationship')?.setValue(relationship);
  }

  onSelectPrefix(contact: AbstractControl, prefix: string) {
    contact.get('prefixPhone')?.patchValue(prefix);
    contact.get('phone')?.patchValue('');
  }

  setTypePhone(contact: AbstractControl) {
    if (contact.value.prefixPhone === '+34') {
      if (contact.value.phone.toString().charAt(0) === '8'
        || contact.value.phone.toString().charAt(0) === '9') {
        this.typePhoneSelect = '1';
        this.correctPhone = true;
        if (contact.value.isPrimaryContact) {
          this.contactByEmail = true;
          this.typePrimaryPhoneSelect = '1';
        }
      } else if (contact.value.phone.toString().charAt(0) === '6'
        || contact.value.phone.toString().charAt(0) === '7') {
        this.typePhoneSelect = '2';
        this.correctPhone = true;
        if (contact.value.isPrimaryContact) {
          this.sessionData = this.storageService.get(this.storageService.contactDataKey);
          this.contactByEmail = this.sessionData.contactData.email ? true : false;
          this.typePrimaryPhoneSelect = '2';
        }
      } else {
        this.correctPhone = false;
      }
    } else {
      this.typePhoneSelect = '2';
      this.correctPhone = true;
      if (contact.value.isPrimaryContact) {
        this.contactByEmail = false;
        this.typePrimaryPhoneSelect = '2';
      }
    }
    contact.get('typePhone')?.patchValue(this.typePhoneList.find(obj => obj.code === this.typePhoneSelect));
  }

  changePrimaryContact(contactChanged: AbstractControl) {
    this.contacts?.controls?.forEach((contact) => {
      contact.get('isPrimaryContact')?.setValue(contact === contactChanged);
    });
    this.setTypePhone(contactChanged)
  }

  setIsInsured(contact: AbstractControl, isInsured: boolean) {
    contact.get('isInsured')?.patchValue(isInsured);
  }

  setContactByEmail(contactByEmail: boolean) {
    this.contactByEmail = contactByEmail;
    this.form.get('contactData')?.get('contactByEmail')?.patchValue(contactByEmail);
  }


  onAddContact() {
    if (this.contacts.length < 3) {
      this.newContact();
    } else {
      this.maxContactsMessage = true;
    }
  }

  onRemoveContact(index: number) {
    this.contacts.removeAt(index);
    if (!this.contacts.controls.some((contact) => contact.get('isPrimaryContact')?.value)) {
      this.contacts.controls[0].get('isPrimaryContact')?.setValue(true);
    }
  }

  showCallMeModal(reason: string) {
    if (this.modalOpen) {
      return;
    }
    this.modalOpen = true;
    const modalRef = this.modalService.open(ConfirmComponent, {
      windowClass: 'modal-small',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.title = this.translate.instant('contactDetails.primaryData.warning');
    switch (reason) {
      case 'address':
        modalRef.componentInstance.body = this.translate.instant('contactDetails.primaryData.notRightAddress');
        break;
      case 'urgent':
        modalRef.componentInstance.body = this.translate.instant('contactDetails.claimUrgentConfirm');
        break;
    }
    modalRef.componentInstance.buttonText = 'Sí';
    modalRef.componentInstance.modalConfirm = true;
    modalRef.result.then(
      (result) => {
        if (result !== 'Deny') {
          this.modalOpen = false;
          const c2cModalRef = this.modalService.open(ClickToCallComponent, {
            centered: true,
            windowClass: 'modal-call',
            backdrop: 'static',
            keyboard: false
          });
          if (reason === 'address') {
            c2cModalRef.componentInstance.motiveC2C = '60002_Problema_dirección_Riesgo';
            c2cModalRef.componentInstance.submotiveC2C = 'El usuario indica que la dirección es incorrecta';
          }
          if (reason === 'urgent') {
            c2cModalRef.componentInstance.motiveC2C = '10004_Urgencias';
            c2cModalRef.componentInstance.submotiveC2C = 'El usuario indica que es urgente';
          }
        } else {
          if (reason === 'address') {
            this.form.get('primaryData')?.get('rightAddress')?.setValue(undefined);
          }
          if (reason === 'urgent') {
            this.form.get('isUrgent')?.setValue(undefined);
          }
          this.modalOpen = false;
        }
      },
      () => {
        //  Dismiss
        this.modalOpen = false;
      }
    );
  }

  handleInputEmailFocus(value: boolean) {
    this.sessionData = this.storageService.get(this.storageService.contactDataKey);
    this.focusAndDeleteAlertEmail = value;
    if (this.typePrimaryPhoneSelect === '2') {
      this.contactByEmail = this.sessionData.contactData.email ? true : false;
    }
    this.form.get('contactData')?.get('email')?.patchValue(this.sessionData.contactData.email ? this.sessionData.contactData.email : '');
  }

  onSubmit() {
    this.form.markAllAsTouched();
    this.sessionData = this.storageService.get(this.storageService.contactDataKey);
    this.focusAndDeleteAlertEmail = false;
    if (this.form.valid && (!this.contactByEmail || (this.contactByEmail && this.sessionData.contactData.email)) && this.correctPhone) {
      this.storageService.save(this.storageService.contactDataKey, this.form.value);
      const declarantAuthorized = this.form.get('declarant')?.get('relationship')?.value.authorized;
      if (declarantAuthorized !== undefined && !declarantAuthorized) {
        const modalRef = this.modalService.open(LlamanosComponent, {
          centered: true,
          windowClass: 'modal-help',
          backdrop: 'static',
          keyboard: false
        });
        // modalRef.componentInstance.motiveLlamanos = '00019';
        modalRef.componentInstance.submotiveLlamanos = `${this.translate.instant(
          'contactDetails.unauthorizedDeclarant'
        )}: ${this.form.get('declarant')?.get('relationship')?.value.description}`;
        modalRef.componentInstance.submotiveShown = `${this.translate.instant(
          'contactDetails.unauthorizedDeclarant'
        )}: ${this.form.get('declarant')?.get('relationship')?.value.description}`;
      } else {
        if (this.form.get('primaryData')?.get('reasonWrongAddress')?.value === 'b') {
          this.masterService.createClickToCall(`60002_Problema_dirección_Riesgo`, `Código postal y localidad (los dos)`);
        } else {
          this.stepTrackerService.updateNameEvent('modulo_hogar_paso_1');
          const currentNameEvent = this.stepTrackerService.getCurrentEventName();
          this.dataLayerService.addDataToDataLayer({
            'event': currentNameEvent

          });
          this.stepTrackerService.updateStep('1');
          const currentStep = this.stepTrackerService.getCurrentStep();
          this.dataLayerService.addDataToDataLayer({
            'event': 'uaevent',
            'eventCategory': 'Funnel Hogar Siniestros',
            'eventAction': 'modulo_hogar',
            'eventLabel': `Step${currentStep}`
          });

          this.nextStep.emit();
        }
      }
    }
  }

  onChangeRightAddress() {
    this.form.get('primaryData')?.get('reasonWrongAddress')?.setValue(null);
  }




}
